/* eslint-disable no-undef */
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { fetchWrapper } from '../../../../_helpers/fetchWrapper';

import Certificate from '../certificate-builder/Certificate';

function CertificateContent() {
  // const lang = useSelector((state) => state.local.local);

  // const handleCertificateTemplateGenerate = async (data) => {
  //   try {
  //     setIsLoading(true);
  //     await fetchWrapper.post('/certificate/template/', data, true);
  //     toast.success(
  //       lang === 'ne' ? 'प्रमाणपत्र सफलतापूर्वक सिर्जना गरियो' : 'Certificate created successful'
  //     );
  //     setIsLoading(false);
  //   } catch (error) {
  //     setIsLoading(false);
  //     console.log(error);
  //   }
  // };

  return (
    <div>
      <Certificate />
    </div>
  );
}

export default CertificateContent;
